import { BeneficiarySliceInitialState } from '../types/BeneficiarySliceInitialState';

export const initialBeneficiaryState: BeneficiarySliceInitialState = {
  beneficiaryListByClaimId: {},
  beneficiaryListByClaimIdRequestsStates: {},
  updatedBeneficiaryRequestState: {
    id: null,
    isLoading: false,
    isFetching: false,
    isSuccess: false,
    isError: false,
  },
};
